var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGavel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "gavel"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_1121",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_1121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gavel_2",
    d: "M4.80775 19.25H14.8077C15.0206 19.25 15.1987 19.3218 15.3422 19.4655C15.4859 19.609 15.5577 19.7872 15.5577 20C15.5577 20.2128 15.4859 20.391 15.3422 20.5345C15.1987 20.6782 15.0206 20.75 14.8077 20.75H4.80775C4.59492 20.75 4.41667 20.6782 4.273 20.5345C4.1295 20.391 4.05775 20.2128 4.05775 20C4.05775 19.7872 4.1295 19.609 4.273 19.4655C4.41667 19.3218 4.59492 19.25 4.80775 19.25ZM8.58075 14.3115L5.823 11.5538C5.47817 11.2089 5.30158 10.7862 5.29325 10.2855C5.28492 9.78483 5.45317 9.35892 5.798 9.00775L6.3115 8.48475L11.6652 13.7885L11.1423 14.3115C10.7974 14.6563 10.3705 14.8288 9.8615 14.8288C9.3525 14.8288 8.92558 14.6563 8.58075 14.3115ZM15.7885 9.66525L10.4848 4.3115L11.0078 3.798C11.3589 3.45317 11.7848 3.28492 12.2855 3.29325C12.7862 3.30158 13.2089 3.47817 13.5538 3.823L16.3115 6.58075C16.6563 6.92558 16.8288 7.3525 16.8288 7.8615C16.8288 8.3705 16.6563 8.79742 16.3115 9.14225L15.7885 9.66525ZM20.073 19.127L7.89625 6.95L8.95 5.89625L21.127 18.073C21.2653 18.2115 21.3362 18.3856 21.3395 18.5952C21.3427 18.8047 21.2718 18.982 21.127 19.127C20.982 19.2718 20.8063 19.3443 20.6 19.3443C20.3937 19.3443 20.218 19.2718 20.073 19.127Z",
    fill: "var(--fill-0, white)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGavel);
export default __webpack_public_path__ + "static/media/icon-gavel.69aae6518c65920c1f8c0d0f643c66e3.svg";
export { ForwardRef as ReactComponent };